/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AttachUserSessionIssuerForm,
  AttachUserSessionIssuerForm$Outbound,
  AttachUserSessionIssuerForm$outboundSchema,
} from "../components/attachusersessionissuerform.js";

export type AttachUserSessionIssuerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type AttachUserSessionIssuerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type AttachUserSessionIssuerSecurity = {
  option1?: AttachUserSessionIssuerSecurityOption1 | undefined;
  option2?: AttachUserSessionIssuerSecurityOption2 | undefined;
};

export type AttachUserSessionIssuerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  attachUserSessionIssuerForm: AttachUserSessionIssuerForm;
};

/** @internal */
export type AttachUserSessionIssuerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const AttachUserSessionIssuerSecurityOption1$outboundSchema:
  z.ZodMiniType<
    AttachUserSessionIssuerSecurityOption1$Outbound,
    AttachUserSessionIssuerSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function attachUserSessionIssuerSecurityOption1ToJSON(
  attachUserSessionIssuerSecurityOption1:
    AttachUserSessionIssuerSecurityOption1,
): string {
  return JSON.stringify(
    AttachUserSessionIssuerSecurityOption1$outboundSchema.parse(
      attachUserSessionIssuerSecurityOption1,
    ),
  );
}

/** @internal */
export type AttachUserSessionIssuerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const AttachUserSessionIssuerSecurityOption2$outboundSchema:
  z.ZodMiniType<
    AttachUserSessionIssuerSecurityOption2$Outbound,
    AttachUserSessionIssuerSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function attachUserSessionIssuerSecurityOption2ToJSON(
  attachUserSessionIssuerSecurityOption2:
    AttachUserSessionIssuerSecurityOption2,
): string {
  return JSON.stringify(
    AttachUserSessionIssuerSecurityOption2$outboundSchema.parse(
      attachUserSessionIssuerSecurityOption2,
    ),
  );
}

/** @internal */
export type AttachUserSessionIssuerSecurity$Outbound = {
  Option1?: AttachUserSessionIssuerSecurityOption1$Outbound | undefined;
  Option2?: AttachUserSessionIssuerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const AttachUserSessionIssuerSecurity$outboundSchema: z.ZodMiniType<
  AttachUserSessionIssuerSecurity$Outbound,
  AttachUserSessionIssuerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => AttachUserSessionIssuerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => AttachUserSessionIssuerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function attachUserSessionIssuerSecurityToJSON(
  attachUserSessionIssuerSecurity: AttachUserSessionIssuerSecurity,
): string {
  return JSON.stringify(
    AttachUserSessionIssuerSecurity$outboundSchema.parse(
      attachUserSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type AttachUserSessionIssuerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  AttachUserSessionIssuerForm: AttachUserSessionIssuerForm$Outbound;
};

/** @internal */
export const AttachUserSessionIssuerRequest$outboundSchema: z.ZodMiniType<
  AttachUserSessionIssuerRequest$Outbound,
  AttachUserSessionIssuerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    attachUserSessionIssuerForm: AttachUserSessionIssuerForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      attachUserSessionIssuerForm: "AttachUserSessionIssuerForm",
    });
  }),
);

export function attachUserSessionIssuerRequestToJSON(
  attachUserSessionIssuerRequest: AttachUserSessionIssuerRequest,
): string {
  return JSON.stringify(
    AttachUserSessionIssuerRequest$outboundSchema.parse(
      attachUserSessionIssuerRequest,
    ),
  );
}
